import { call, put, takeEvery } from 'redux-saga/effects';
import { FetchCarrier, logisticsActionCreators, LogisticsActionKeys } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import * as api from '../logisticsApi';
import { ICarrier } from '../logisticsInterfaces';

function* fetchCarrierSaga(action: FetchCarrier) {
  yield put(uiActionCreators.showFullPageLoading());
  const response: IApiExecuteRespone<ICarrier> = yield call(api.fetchCarrier, action.payload.carrierId);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(logisticsActionCreators.setCarriers([response.value]));
  }

  yield put(uiActionCreators.hideFullPageLoading());
}

export function* watchFetchCarrier() {
  yield takeEvery(LogisticsActionKeys.FETCH_CARRIER, fetchCarrierSaga);
}
